import { baseUrl } from 'api/config'
import axios from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
})

// Add a response interceptor
api.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config
    if ((error as any).response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      const newAccessToken = await refreshAccessToken()
      if (newAccessToken) {
        api.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`
        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`
        return api(originalRequest)
      }
    }
    return Promise.reject(error)
  }
)

export const refreshAccessToken = async () => {
  const slackUserId = localStorage.getItem('slack_user_id')
  const { data } = await axios.get(`${baseUrl}/aws/users/${slackUserId}`)
  const refreshToken = data ? data.googleRefreshToken : null

  if (!refreshToken) {
    console.error('No refresh token available')
    return null
  }

  try {
    const response = await axios.post(`${baseUrl}/aws/refreshtoken`, { refreshToken })
    const { newAccessToken, expiresIn } = response.data
    localStorage.setItem('google_access_token', newAccessToken)
    setTimeout(refreshAccessToken, (expiresIn - 60) * 1000) // Refresh the token 1 minute before it expires
    return newAccessToken
  } catch (error) {
    console.error('Failed to refresh token', error)
    return null
  }
}

export default api
